<template>
    <div class="row">
        <div class="col">
            <h2 class="titre">Vigilance - évaluation</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Période d'évaluation du :</label>
                </div>
                <div class="col txt left">
                    {{ $commun.formatDateHeure(evaluation.evaluationDebutDate) }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Numéro de client Bijou :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.bijouNumeroClient }}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Au :</label>
                </div>
                <div class="col txt left">
                    {{ $commun.formatDateHeure(evaluation.evaluationFinDate) }}
                </div>
            </div>
        </div>
    </div>
    <LiaisonsMiseEvaluation ref="consulterChampsMiseEvaluation"
                            :liaisonsEvaluation="liaisonsEvaluation"/>
    <div class="row">
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Faits connus :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.faitsConnus }}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Proximité du casino :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.proximite }}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Gradation des mises :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.gradation }}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Fréquence des transactions :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.transaction }}
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-3 text-right lbl">État du client tel que perçu : </div>
            <div class="col-3 left" v-if="!evaluation.etatsEvaluation"> ... </div>
            <div class="col-3 left" v-else>
                {{ etatString }}
            </div>    
        </div>
        <div class="row">
            <div class="col-3"></div>
            <div class="col-3 txt left">
                {{ evaluation.etatCommentaire }}
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-3 text-right lbl">Propos du client</div>
            <div class="col-3 left" v-if="!evaluation.proposEvaluation"> ... </div>
            <div class="col-3 left" v-else>
                {{ proposString }}
            </div>
        </div>
        <div class="row">
            <div class="col-3"></div>
            <div class="col-3 txt left">
                {{ evaluation.proposCommentaire }}
            </div>
        </div>
        <hr>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Informations supplémentaires :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.autreCommentaire }}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Signes non verbaux observés :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.signeCommentaire }}
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="row">
                <div class="col-6 lbl text-vertical-center">
                    <label>Évaluation effectuée par :</label>
                </div>
                <div class="col txt left">
                    {{ evaluation.premierSignataireDescription }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 lbl text-vertical-center">

                </div>
                <div class="col txt left">
                    {{ evaluation.deuxiemeSignataireDescription }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 lbl text-vertical-center">

                </div>
                <div class="col txt left">
                    {{ evaluation.troisiemeSignataireDescription }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 lbl text-vertical-center">

                </div>
                <div class="col txt left">
                    {{ evaluation.quatriemeSignataireDescription }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 lbl text-vertical-center">

                </div>
                <div class="col txt left">
                    {{ evaluation.cinquiemeSignataireDescription }}
                </div>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="row">
            <div class="col-6 lbl text-vertical-center">
                <label>Évaluation effectuée le :</label>
            </div>
            <div class="col txt left">
                {{ $commun.formatDateHeure(evaluation.creerLe) }}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lbl text-vertical-center">
                <label>Évaluation effectuée par :</label>
            </div>
            <div class="col txt left">
                {{ evaluation.creerParDescription }}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lbl text-vertical-center">
                <label>Évaluation enregistrée le :</label>
            </div>
            <div class="col txt left">
                {{ $commun.formatDateHeure(evaluation.modifierLe) }}
            </div>
        </div>
    </div>

    <ButtonBar @fermer="fermer"/>
</template>
<script>
import ButtonBar from '../../../components/dossier/Consulter/ButtonBarEvaluation.vue'
import LiaisonsMiseEvaluation from './LiaisonsMiseEvaluation.vue'
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
    name: 'ConsulterEvaluation',
    components: {
        ButtonBar,
        LiaisonsMiseEvaluation,
    },
    beforeMount() {
        this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Consulter une Evaluation");
        this.getEvaluation();

    },
    data() {
        return {
            isDataLoading: false,
            evaluation: {},
            liaisonsEvaluation: {},
            typeJeuLibelles: {},
            jeuxLibelles: {},
            proposLibelles: {},
            etatsLibelles: {},
            listeEtats: [],
            listePropos: [],
        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil'
        }),
        etatString: function () {
            let etatString = "";
            this.evaluation.etatsEvaluation.liste.forEach((etat) => etatString += etat.etatEvaluationAfficher + " / ");
            return etatString.slice(0, -2);
        },
        proposString: function () {
            let proposString = "";
            this.evaluation.proposEvaluation.liste.forEach((etat) => proposString += etat.proposEvaluationAfficher + " / ");
            return proposString.slice(0, -2);
        }
    },
    methods: {
        getEvaluation() {
            this.$store.dispatch('evaluation/consulterEvaluationAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site
            }).then((res) => {
                this.assignerEvaluation(res);
                this.isDataLoading = false;
            })
        },
        assignerEvaluation(res) {
            this.evaluation = res.data.entite;
            this.liaisonsEvaluation = res.data.entite.liaisonMiseEvaluation;
            this.typeJeuLibelles = res.data.entiteDecision.typeJeu.libelles;
            this.jeuxLibelles = res.data.entiteDecision.jeux.libelles;
            this.proposLibelles = res.data.entiteDecision.proposEvaluation.libelles;
            this.etatsLibelles = res.data.entiteDecision.etatsEvaluation.libelles;
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },
    },
}
</script>
